import React from "react";
import ReactDOM from "react-dom";
import AbrfCheck from "./accept-terms";

ReactDOM.render(<AbrfCheck />, document.getElementById("root"));
